import z from "zod";

export const invoiceCountryCodes = z.enum(["NO", "SE", "DK", "FI"]);

export type InvoiceCountryCode = z.infer<typeof invoiceCountryCodes>;
